'use strict';

module.exports = require('./LM');
module.exports.Matrix = require('ml-matrix');
module.exports.Matrix.algebra = require('./algebra');



// WEBPACK FOOTER //
// ./node_modules/ml-optimize-lorentzian/node_modules/ml-curve-fitting/src/index.js